import React, { Fragment } from 'react';

import via1 from '../../../images/via1.jpg';
import via2 from '../../../images/via2.jpg';

const RightPlateVia = () => (
  <Fragment>
    <p>
      Before you start driving, you will need to go online in the Via Driver App with the correct license plate of the car you've been assigned.
    </p>
    <img className="faq-image-compress faq-image-center" src={via1} alt="Via 1" />
    <br />
    <img className="faq-image-compress faq-image-center" src={via2} alt="Via 2" />
  </Fragment>
);

export default RightPlateVia;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/RightPlateVia.js